import React from 'react';
import useInView from '../Animation/useInView.ts';
import styles from './HeroBackground.module.css';

interface ThemeColors {
    primary: string;
    light: string;
    dark?: string;
    glow: string;
    gradientStart: string;
    gradientEnd: string;
    subtitle: string;
}

interface HeroBackgroundProps {
    title?: string;
    subtitle?: string;
    theme: ThemeColors;
    children: React.ReactNode;
    className?: string;
    id?: string;
}

const HeroBackground: React.FC<HeroBackgroundProps> = ({
    title,
    subtitle,
    theme,
    children,
    className = "",
    id
}) => {
    const { ref, isInView } = useInView({ threshold: 0.1, triggerOnce: true });

    return (
        <section
            ref={ref}
            id={id}
            style={{
                '--hero-primary': theme.primary,
                '--hero-light': theme.light,
                '--hero-dark': theme.dark || theme.primary,
                '--hero-glow': theme.glow,
                '--hero-gradient-0': theme.gradientStart,
                '--hero-gradient-100': theme.gradientEnd,
                '--hero-subtitle-color': theme.subtitle,
            } as React.CSSProperties}
            className={`${styles.section} ${className} ${isInView ? styles.visible : ''}`}
        >
            <div className={styles.container}>
                {(title || subtitle) && (
                    <div className={styles.header}>
                        {title && <h2 className={styles.title}>{title}</h2>}
                        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
                    </div>
                )}
                <div className={styles.content}>
                    {children}
                </div>
            </div>
        </section>
    );
};

export default HeroBackground;
